export default "__VITE_ASSET__gLImhBx9__"